import {
  Avatar,
  AvatarImage,
  AvatarFallback,
} from "../../../../components/ui/avatar";
import { stringToColour } from "../../../../../app/utils/changeBackgroundColorOfInitials";
import { formatMoneyValue } from "../../../../../app/utils/formatMoneyValue";
import { getNameInitial } from "../../../../../app/utils/getNameInitial";
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from "../../../../components/ui/card";
import { Team } from "../../../../../app/entities/Team";
import { EditTeamDetails } from "./EditTeamDetails.tsx";
import { AddMembers } from "./AddMembers.tsx/index.tsx";

import { useAuth } from "../../../../../app/hooks/useAuth.ts";
import { UserRoleEnum } from "@/app/services/usersService/user.ts";
import { ExecutivesCard } from "./ExecutivesCard.tsx";

export const TeamCardDetails = ({
  _id,
  name,
  about,
  manager,
  supervisor,
  leader,
  members,
  members_count: membersCount,
  transactions_count: transactionCount,
  transactions_total: transactionTotal,
}: Team) => {
  const { PERMISSIONS, isLeader } = useAuth();
  const noTeam = _id === "semTime";
  return (
    <Card className="relative w-full">
      <CardHeader>
        {PERMISSIONS.team.edit && !noTeam && (
          <div className="absolute right-6 top-6 flex items-center justify-center rounded-sm px-1 py-1">
            <EditTeamDetails />
          </div>
        )}
        <h3 className="text-2xl font-semibold">{name}</h3>
        <p className="font-medium text-black04">{about}</p>
      </CardHeader>
      <CardContent>
        {!noTeam && (
          <div className="mb-4 flex flex-col gap-4">
            <ExecutivesCard
              type={UserRoleEnum.MANAGER}
              executive={manager}
              team={name}
            />
            {!isLeader && (
              <ExecutivesCard
                type={UserRoleEnum.SUPERVISOR}
                executive={supervisor}
                team={name}
              />
            )}
            <ExecutivesCard
              type={UserRoleEnum.LEADER}
              executive={leader}
              team={name}
            />
          </div>
        )}
        <div className="flex items-center justify-center gap-2">
          <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-gray02 px-3 py-2">
            <p className="font-semibold">{transactionCount || 0}</p>
            <p className="text-xs font-medium text-black04">
              Saques realizados
            </p>
          </div>
          <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-gray02 px-3 py-2">
            <p className="font-semibold">
              {transactionTotal
                ? formatMoneyValue(transactionTotal)
                : formatMoneyValue(0)}
            </p>
            <p className="text-xs font-medium text-black04">
              Valor movimentado
            </p>
          </div>
        </div>
        <div className="mt-4 w-full border-[1px] border-white02" />
      </CardContent>
      <CardFooter className="flex flex-col items-start">
        <h3 className="text-sm font-semibold"> {membersCount || 0} membros</h3>
        <div className="mt-4 flex items-center">
          {members?.map((member, index) => {
            const avatarStyle = index > 0 ? { marginLeft: "-6px" } : {};

            if (index >= 10) {
              return null;
            }

            return (
              <Avatar
                key={member._id}
                className="h-8 w-8 border-2 border-white"
                style={avatarStyle}
              >
                <AvatarImage
                  src={`${import.meta.env.VITE_CDN_URL}${member.profileImageUrl ? member.profileImageUrl : ""}`}
                />
                <AvatarFallback
                  style={{
                    backgroundColor: `${stringToColour(member.name)}`,
                  }}
                  className="text-sm"
                >
                  {getNameInitial(member.name)}
                </AvatarFallback>
              </Avatar>
            );
          })}
          {members.length > 10 && (
            <>
              <div
                style={{
                  backgroundColor: `${stringToColour("Henrique novais")}`,
                }}
                className="-ml-[4px] h-8 w-8 rounded-full border-2 border-white"
              >
                <div className="ml-2">+{members.length - 10}</div>
              </div>
            </>
          )}
        </div>
        {PERMISSIONS.team.addMembers && !noTeam && <AddMembers />}
      </CardFooter>
    </Card>
  );
};
